import { create } from 'zustand';

// 공지사항 타입 정의 (NoticeBoard와 동일하게)
export interface Notice {
  id: number;
  isAdmin?: boolean;
  title: string;
  language?: string;
  content: string;
  createdAt: string; // ISO-8601 형식의 날짜 문자열
  isFixed: boolean;
  isPopup?: boolean;
  isHidden?: boolean;
  popupExpiredAt?: string;
  viewCount: number;
  attachments?: string;
}

// 상태 관리를 위한 인터페이스
interface NoticeStore {
  selectedNotice: Notice | null; // 선택된 공지사항
  setSelectedNotice: (notice: Notice) => void; // 선택된 공지사항 설정 함수
}

// Zustand를 사용한 공지사항 상태 관리 스토어
export const useNoticeStore = create<NoticeStore>((set) => ({
  selectedNotice: null, // 초기값
  setSelectedNotice: (notice) => set({ selectedNotice: notice }) // 상태 업데이트
}));
